module.exports = __webpack_public_path__ + "3a17564e2a7146e901e7349841afb1f3.MP3";